import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, Grid, TextField } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import { authFetch } from '~/services/fetch';
import { Controller, UseFormGetValues, UseFormSetValue, type UseFormResetField, type UseFormWatch } from 'react-hook-form';
import { Method } from 'axios';
import { element } from 'prop-types';
import { StateMethods, useHookstate, type State } from '@hookstate/core';

type CrudSelectAutocompleteMultipleProps = {
  readonly register: any;
  readonly name: string;
  readonly model: any;
  readonly control: any;
  readonly placeholder?: string;
  readonly optionSelect?: any;
  readonly method?: Method;
  readonly getValues?: UseFormGetValues<any>;
  readonly setFormValue: UseFormSetValue<any>;
  readonly required?: boolean
  readonly independent?: boolean
  readonly dependent?: boolean
  readonly filter?: StateMethods<readonly number[] | null>
  readonly filterName?: string
  readonly watch?: UseFormWatch<any>
  readonly resetField?: UseFormResetField<any>
  readonly nameValue?: string
}


export default function CrudSelectAutocompleteMultiple(props: CrudSelectAutocompleteMultipleProps) {
  const { translate } = useLang();
  const { register, name, model, control, placeholder = '', optionSelect, method = 'POST', getValues, setFormValue, required = false, watch, resetField } = props;
  const [items, setItems] = useState([]);
  const currentValue = useHookstate<readonly number[]>([])
  const disabledField = useHookstate(true)
  const loading = useHookstate(false)
  const value = useHookstate<readonly { readonly key: number, readonly label: string, readonly value: number }[]>([])

  useEffect(() => {
    const getValueSelect = getValues ? getValues(name) : ''
    setFormValue(name, value?.map((agency) => agency.key ?? []))

    if (getValueSelect && getValues) {
      getValueSelect.map((item) => {
        value.merge([{
          key: item['id'],
          value: item['id'],
          label: item['name'],
        }])
      })
    }

    if (watch && watch('can_manage_any_agency')) {
      if (value?.length && resetField) {
        value.set([])
        resetField('agencies_managed')
      }
      setFormValue('agencies_managed', [])
      disabledField.set(true)
    } else {
      disabledField.set(false)
    }
  }, [watch ? watch('can_manage_any_agency') : ''])

  useEffect(() => {
    loading.set(true)
    const fetchData = async () => {
      const targetUrl = `/${model}/`;
      await authFetch({
        url: targetUrl,
        method,
        data: {
          limit: 100000,
          filters: [],
          orders: [{ field: 'name', sort: 'asc' }]
        }
      }).then((response) => {
        const data = method === 'POST' ? response.data.data : response.data

        if (items?.length <= 0 && data?.length > 0) {
          setItems(data);
        }

      }).finally(() => {
        loading.set(false)
      });
    }

    fetchData()
      .catch(console.error);
  }, [])

  const listItems = items.map((item: any) => ({
    key: item['id'],
    value: item['id'],
    label: optionSelect ? item[optionSelect] : item['name'],
  })).filter((value1, idx1, arr1) => arr1.findIndex((value2) => (value2.key === value1.key)) === idx1)



  return (
    <Grid item xs={4}>
      <Controller
        {...register(`${name}`)}
        name={name}
        control={control}
        render={(props) => {
          return (
            <Autocomplete
              {...props}
              multiple
              loading={loading.get()}
              disabled={disabledField.get()}
              options={listItems.length ? listItems : []}
              getOptionLabel={(option) => option?.label}
              isOptionEqualToValue={(option, value) => option?.key === value?.key}
              value={[...value.get()]}
              onChange={(_, data) => {
                currentValue.set(data?.map((agency) => agency.key ?? []))
                setFormValue(name, data?.map((agency) => agency.key ?? []))

                const dataFiltered = props.field.value && listItems ? data.filter((element) => listItems.map((agency) => agency.key === element.key)) : []
                const dataFormated = JSON.parse(JSON.stringify((dataFiltered)))
                value.set(dataFormated)
              }}
              noOptionsText={translate('No options')}
              renderInput={(params) =>
                <TextField
                  {...params}
                  label={translate(placeholder)}
                  required={required}
                />
              }
            />
          )
        }}
      />
    </Grid>
  )
}

